export interface IContactPhone {
  id: string;
  label: string;
  phone: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface IContactPhoneApiModel {
  id: string;
  label: string;
  phone: string;
  createdAt: string;
  updatedAt: string;
}

export default class ContactPhone implements IContactPhone {
  public readonly id: string;

  public readonly label: string;

  public readonly phone: string;

  public readonly createdAt: Date;

  public readonly updatedAt: Date;

  constructor(
    id: string,
    label: string,
    phone: string,
    createdAt: Date,
    updatedAt: Date,
  ) {
    this.id = id;
    this.label = label;
    this.phone = phone;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  static fromApiModel(apiModel: IContactPhoneApiModel) {
    const { id, label, phone } = apiModel;

    const createdAt = new Date(Date.parse(apiModel.createdAt));
    const updatedAt = new Date(Date.parse(apiModel.updatedAt));

    return new ContactPhone(id, label, phone, createdAt, updatedAt);
  }

  static arrayFromApiModel(arrayApiModel: IContactPhoneApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      return this.fromApiModel(apiModel);
    });

    return array;
  }
}
